<template>
    <div id="service-content" class="giftcard-content">
    <!-- <div id="service-content" class="p-6 giftcard-content" style="min-width: 495px;"> -->
        <div slot="header" class="flex justify-between pb-base giftcard-header">
            <div class="flex left-header">
                <div class="con-input-search vs-table--search w-full ml-0">
                    <input type="text" class="input-search vs-table--search-input w-full h-full rounded-item" v-model="search" @keyup="searchGiftcard" placeholder="Code"/>
                    <i class="vs-icon notranslate icon-scale material-icons null">search</i>
                </div>
                <div class="giftcard-select giftcard-select-status">
                    <v-select @input="filterStatus($event)" :value="selected_status" label="name" :options="statusList" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :searchable="false" />
                    <img src="../../assets/images/charging-circle.png" class="charging-circle-img" />
                </div>
                <div class="flex-center date-filter">
                    <date-picker class="ml-5 filter-date-picker" :format="date_format_string" v-model="date_filter" type="date" :editable="false" placeholder="Choose date" @change="selectedDate"></date-picker>
                </div>
                <div class="giftcard-select giftcard-select-type">
                    <v-select @input="filterType($event)" :value="selected_type" label="name" :options="typeList" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :searchable="false" />
                    <img src="../../assets/images/charging-circle.png" class="charging-circle-img" />
                </div>
            </div>

            <div class="flex right-header">
                <vs-button class="gradient gradient-primary no-shadow header-btn create-btn" @click="createGiftcardPopup.isOpen = true">
                    <div class="flex-center">
                        <img src="../../assets/images/plus-square-icon.png" class="mr-2 plus-square-icon" />
                        <span>Create</span>
                    </div>
                </vs-button>

                <!-- <vs-button class="gradient gradient-primary no-shadow header-btn export-btn">
                    <div class="flex-center">
                        <img src="../../assets/images/excel.png" class="mr-2 excel-icon" />
                        <span>Export</span>
                    </div>
                </vs-button> -->
                

                <!-- <vs-button class="gradient gradient-primary no-shadow header-btn import-btn">
                    <div class="flex-center">
                        <img src="../../assets/images/import-icon.png" class="mr-2 import-icon" />
                        <span>Import</span>
                    </div>
                </vs-button> -->
                <vs-button class="gradient gradient-primary no-shadow header-btn import-btn" @click="importGiftcardFormPopup.isOpen = true">
                    <div class="flex-center">
                        <img src="../../assets/images/import-icon.png" class="mr-2 import-icon" />
                        <span>Import</span>
                    </div>
                </vs-button>
                <!-- <input type="file" @change="onFileChange" class="hidden" ref="importFileInput">
                <vs-button class="gradient gradient-primary no-shadow header-btn import-btn file-import-btn" @click="$refs.importFileInput.click()">
                    <div class="flex-center">
                        <img src="../../assets/images/import-icon.png" class="mr-2 import-icon" />
                        <span>File Import</span>
                    </div>
                </vs-button> -->
                <vs-dropdown vs-trigger-click class="export-dropdown cursor-pointer" style="z-index: 101">
                    <a href.prevent class="gradient gradient-primary no-shadow header-btn import-btn rounded-item flex-center file-import-btn">
                        <div class="flex-center">
                            <img src="../../assets/images/import-icon.png" class="mr-2 import-icon" />
                            <span>File Import</span>
                        </div>
                    </a>
                    <vs-dropdown-menu class="export-giftcard-dropdown-menu">
                        <vs-dropdown-item>
                            <div class="flex">
                                <input type="file" @change="onFileChange" class="hidden" ref="importFileInput">
                                <vs-button class="gradient gradient-primary no-shadow header-btn" @click="$refs.importFileInput.click()">
                                    <div class="flex-center">
                                        <span>Upload</span>
                                    </div>
                                </vs-button>

                                <vs-button class="gradient gradient-primary no-shadow header-btn download-btn ml-3" @click="downloadTemplate">
                                    <div class="flex-center">
                                        <span>Download Template</span>
                                    </div>
                                </vs-button>
                            </div>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
                <!-- <vs-dropdown vs-trigger-click class="export-dropdown cursor-pointer" style="z-index: 101">
                    <a href.prevent class="gradient gradient-primary no-shadow header-btn import-btn rounded-item flex-center">
                        <div class="flex-center">
                            <img src="../../assets/images/import-icon.png" class="mr-2 import-icon" />
                            <span>Import</span>
                        </div>
                    </a>
                    <vs-dropdown-menu class="export-giftcard-dropdown-menu">
                        <vs-dropdown-item>
                            <div class="flex">
                                <input type="file" @change="onFileChange" class="hidden" ref="importFileInput">
                                <vs-button class="gradient gradient-primary no-shadow header-btn" @click="importGiftcardFormPopup.isOpen = true">
                                    <div class="flex-center">
                                        <span>Form</span>
                                    </div>
                                </vs-button>

                                <vs-button class="gradient gradient-primary no-shadow header-btn download-btn ml-3" @click="$refs.importFileInput.click()">
                                    <div class="flex-center">
                                        <span>Excel file</span>
                                    </div>
                                </vs-button>
                            </div>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown> -->
                <!-- <vs-dropdown vs-trigger-click class="export-dropdown cursor-pointer" style="z-index: 101">
                    <a href.prevent class="gradient gradient-primary no-shadow header-btn export-btn rounded-item flex-center">
                        <div class="flex-center">
                            <img src="../../assets/images/excel.png" class="mr-2 excel-icon" />
                            <span>Export</span>
                        </div>
                    </a>
                    <vs-dropdown-menu class="export-giftcard-dropdown-menu">
                        <vs-dropdown-item>
                            <div class="flex">
                                <vs-button class="gradient gradient-primary no-shadow header-btn export-btn mr-3" @click="exportGiftCard(false)">
                                    <div class="flex-center">
                                        <span>Filter Export</span>
                                    </div>
                                </vs-button>
                                <vs-button class="gradient gradient-primary no-shadow header-btn export-btn" @click="exportGiftCard(true)">
                                    <div class="flex-center">
                                        <span>Full Export</span>
                                    </div>
                                </vs-button>
                            </div>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown> -->
                <a href.prevent class="gradient gradient-primary no-shadow cursor-pointer header-btn export-btn rounded-item flex-center" @click="exportGiftCard(false)">
                    <div class="flex-center">
                        <img src="../../assets/images/excel.png" class="mr-2 excel-icon" />
                        <span>Export</span>
                    </div>
                </a>

                <!-- <vs-dropdown vs-trigger-click class="export-dropdown cursor-pointer" style="z-index: 101">
                    <a href.prevent class="gradient gradient-primary no-shadow header-btn import-btn rounded-item flex-center">
                        <div class="flex-center">
                            <img src="../../assets/images/import-icon.png" class="mr-2 import-icon" />
                            <span>Import</span>
                        </div>
                    </a>
                    <vs-dropdown-menu class="export-giftcard-dropdown-menu">
                        <vs-dropdown-item>
                            <div class="flex">
                                <input type="file" @change="onFileChange" class="hidden" ref="importFileInput">
                                <vs-button class="gradient gradient-primary no-shadow header-btn" @click="$refs.importFileInput.click()">
                                    <div class="flex-center">
                                        <span>Upload</span>
                                    </div>
                                </vs-button>

                                <vs-button class="gradient gradient-primary no-shadow header-btn download-btn ml-3" @click="downloadTemplate">
                                    <div class="flex-center">
                                        <span>Download Template</span>
                                    </div>
                                </vs-button>
                            </div>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown> -->
            </div>
        </div>

        <div class="service-list-content giftcard-list-content-table" style="z-index: 1;">
            <!-- <div class="service-header flex p-6 px-3 text-sm font-bold">
                <div class="w-1/12 px-2 text-uppercase text-center">#</div>
                <div class="w-3/12 px-2 text-uppercase text-center">Code</div>
                <div class="w-1/12 px-2 text-uppercase text-center">Amount</div>
                <div class="w-2/12 px-2 text-uppercase text-center">Balance</div>
                <div class="w-1/12 px-2 text-uppercase text-center">Price</div>
                <div class="w-2/12 px-2 text-uppercase text-center">Created At</div>
                <div class="w-2/12 px-2 text-uppercase text-center">Status</div>
            </div>
            <div v-if="giftCardData && giftCardData.items && giftCardData.items.length > 0">
                <div class="service-item flex align-center p-3 mb-5 shadow-sm cursor-pointer" v-for="(item, index) in giftCardData.items" :key="index" @click="showGiftCardHistory(item)">
                    <div class="w-1/12 px-2 text-center">{{index + 1}}</div>
                    <div class="w-3/12 px-2 text-center text-primary">{{formatGiftCardCode(item.code)}}</div>
                    <div class="w-1/12 px-2 text-center">{{item.amount}}</div>
                    <div class="w-2/12 px-2 text-center">{{item.balance}}</div>
                    <div class="w-1/12 px-2 text-center">${{item.price}}</div>
                    <div class="w-2/12 px-2 text-center">
                        <p>{{changeFormat(item.created_at)}}</p>
                        <p>{{getTime(item.created_at)}}</p>
                    </div>
                    <div class="w-2/12 px-2 text-center">{{getStatus(item.status)}}</div>
                </div>
            </div>
            <div class="p-base text-center" v-else>
                No data available
            </div> -->
            <vs-table class="overflow-auto" ref="table" :max-items="itemsPerPage" :data="giftCardData.items">
                <template slot="thead">
                    <vs-th class="w-1/12 px-2 text-center">
                        <div class="text-uppercase mb-0">#</div>
                    </vs-th>
                    <vs-th class="w-3/12 px-2 text-center" sort-key="code">
                        <div class="text-uppercase mb-0" @click="cur_sort_type='code', sort()">Code</div>
                    </vs-th>
                    <vs-th class="w-1/12 px-2 text-center" sort-key="amount">
                        <div class="text-uppercase mb-0" @click="cur_sort_type='amount', sort()">Amount</div>
                    </vs-th>
                    <vs-th class="w-1/12 px-2 text-center" sort-key="balance">
                        <div class="text-uppercase mb-0" @click="cur_sort_type='balance', sort()">Balance</div>
                    </vs-th>
                    <vs-th class="w-1/12 px-2 text-center" sort-key="price">
                        <div class="text-uppercase mb-0" @click="cur_sort_type='price', sort()">Price</div>
                    </vs-th>
                    <vs-th class="w-2/12 px-2 text-center" sort-key="created_at">
                        <div class="text-uppercase mb-0" @click="cur_sort_type='created_at', sort()">Created At</div>
                    </vs-th>
                    <vs-th class="w-2/12 px-2 text-center">
                        <div class="text-uppercase mb-0">Sold At</div>
                    </vs-th>
                    <vs-th class="w-2/12 px-2 text-center" sort-key="status">
                        <div class="text-uppercase mb-0" @click="cur_sort_type='status', sort()">Status</div>
                    </vs-th>
                </template>

                <template slot-scope="{data}">
                    <tbody id="customer-list-table" class="vs-con-loading__container">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click.native="showGiftCardHistory(tr)" class="rounded-10">
                            <vs-td class="w-1/12 px-2 text-center position-relative" :class="{'has-import': tr.type == 'import'}">
                                {{indextr + 1}}
                                <div class="text-sm px-6 bg-warning text-white import-status" v-if="tr.type == 'import'">Imported</div>
                            </vs-td>
                            <vs-td class="w-3/12 px-2 text-center text-primary">{{formatGiftCardCode(tr.code)}}</vs-td>
                            <vs-td class="w-1/12 px-2 text-center">
                                <span v-if="tr.amount != null">${{tr.amount}}</span>
                                <span v-else>N/A</span>
                            </vs-td>
                            <vs-td class="w-1/12 px-2 text-center">
                                <span v-if="tr.balance != null">${{tr.balance}}</span>
                                <span v-else>N/A</span>
                            </vs-td>
                            <vs-td class="w-1/12 px-2 text-center">
                                <span v-if="tr.price != null">${{tr.price}}</span>
                                <span v-else>N/A</span>
                            </vs-td>
                            <vs-td class="w-2/12 px-2 text-center">
                                <p>{{changeFormat(tr.created_at)}}</p>
                                <p>{{getTime(tr.created_at)}}</p>
                            </vs-td>
                            <vs-td class="w-2/12 px-2 text-center">
                                <p>{{changeFormat(tr.sold_date)}}</p>
                                <p>{{getTime(tr.sold_date)}}</p>
                            </vs-td>
                            <vs-td class="w-2/12 px-2 text-center">{{getStatus(tr.status)}}</vs-td>
                        </vs-tr>
                    </tbody>
                </template>
            </vs-table>
        </div>
        <div v-if="giftCardData._meta.pageCount && giftCardData._meta.pageCount > 1">
            <custom-pagination
                class="custom-pagination"
                :totalPages="parseInt(giftCardData._meta.pageCount)"
                :currentPage="currentPage"
                @pageChanged="changePage"
                :key="page_key"
            ></custom-pagination>
        </div>
        <redemption-history v-if="activeGiftCard" :popupRedemptionHistory="popupRedemptionHistory" :activeGiftCard="activeGiftCard" :key="history_key"></redemption-history>
        <create-giftcard-popup :createGiftcardPopup="createGiftcardPopup" @GetData="getData"></create-giftcard-popup>
        <import-giftcard-form-popup :importGiftcardFormPopup="importGiftcardFormPopup" @GetData="getData"></import-giftcard-form-popup>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import vSelect from 'vue-select';
import moment from 'moment';
import { changeFormatHelper, formatDateString, formatExportDateString } from '../../helper/datetimeHelper';
import FileDownload from'js-file-download';
import axios from "axios";
import XLSX from 'xlsx';
export default {
    name: 'gift-card-content',
    components: { vSelect, DatePicker },
    data() {
        let date_format_string = formatDateString();
        let format_export_date_string = formatExportDateString();

        const STATUS_NOT_SOLD_YET = 0;
        const STATUS_SOLD = 1;
        const STATUS_USED_UP = 2;
        const STATUS_CANCELLED = 99;

        let statusList = [
            { id: -1, name: 'All Status', status: -1 },
            { id: 0, name: 'Not Sold Yet', status: STATUS_NOT_SOLD_YET },
            { id: 1, name: 'Sold', status: STATUS_SOLD },
            { id: 2, name: 'Used up', status: STATUS_USED_UP },
            { id: 3, name: 'Cancelled', status: STATUS_CANCELLED },
        ];

        let selected_status = { id: -1, name: 'Select Status' };

        let typeList = [
            { id: -1, name: 'All Type', type: 'all' },
            { id: 0, name: 'Created', type: 'create' },
            { id: 1, name: 'Imported', type: 'import' }
        ]

        let selected_type = { id: -1, name: 'Select Type', type: 'all' }
        return {
            STATUS_NOT_SOLD_YET,
            STATUS_SOLD,
            STATUS_USED_UP,
            STATUS_CANCELLED,
            popupActive: false,
            statusList,
            selected_status,
            typeList,
            selected_type,
            search: '',
            isOpenLoading: false,
            action_type: '',
            popupRedemptionHistory: {
                isOpen: false
            },
            date_format_string,
            format_export_date_string,
            date_filter: null,
            cur_sort_type: 'id',
            sort_key: {
                type: "id",
                key: 0
            },
            loaded_data_num: 0,
            // giftCardData: {
            //     items: [
            //         {
            //             id: 1,
            //             code: '4759433723373131',
            //             amount: 100,
            //             balance: 100,
            //             price: 90,
            //             data: {},
            //             customer_id: 3,
            //             customer_name: 'Tam Nguyen',
            //             customer_phone: '6155451324',
            //             type: 'create',
            //             source: 'insight',
            //             staff_id: 1,
            //             staff_name: 'Tam Nguyen',
            //             status: 1,
            //             created_at: '2020-12-11 15:27:26',
            //             updated_at: '2020-12-11 15:27:26',
            //             history: [
            //                 {
            //                     id: 1,
            //                     gift_card_id: 1,
            //                     amount: 100,
            //                     balance: 100,
            //                     order_id: 12,
            //                     type: 'creation',
            //                     data: null,
            //                     status: 1,
            //                     created_at: '2020-12-11 15:35:50',
            //                     updated_at: '2020-12-11 15:35:50'
            //                 },
            //                 {
            //                     id: 2,
            //                     gift_card_id: 1,
            //                     amount: 25,
            //                     balance: 75,
            //                     order_id: 13,
            //                     type: 'redemption',
            //                     data: null,
            //                     status: 1,
            //                     created_at: '2020-12-11 15:35:50',
            //                     updated_at: '2020-12-11 15:35:50'
            //                 }
            //             ]
            //         }
            //     ],
            //     _links: {},
            //     _meta: {
            //         totalCount: 1,
            //         pageCount: 1,
            //         currentPage: 1,
            //         perPage: 20
            //     }
            // },
            activeGiftCard: null,
            history_key: 0,
            currentPage: 1,
            itemsPerPage: 10,
            page_key: 0,
            createGiftcardPopup: {
                isOpen: false
            },
            importGiftcardFormPopup: {
                isOpen: false
            }
        }
    },
    watch: {
        loaded_data_num: {
            immediate: true,
            handler() {
                if(this.loaded_data_num >= 1) {
                    this.closeLoading();
                } else {
                    this.action_type = "Get data";
                    this.openLoadingInDiv();
                }
            }
        }
    },
    methods: {
        openLoadingInDiv(){
          this.$vs.loading({
            container: '#app',
            scale: 0.8
          })
          if(this.loadTime){
              clearTimeout(this.loadTime);
              this.loadTime = null;
          }
          this.isOpenLoading = true;
          this.loadTime = setTimeout( ()=> {
              if(this.isOpenLoading) {
                  this.closeLoading();
                  this.$vs.dialog({
                      color: 'danger',
                      title: 'Notification',
                      text: this.action_type + ' giftcard failed',
                      acceptText: 'OK'
                  })
              }
          }, 10000);
        },
        closeLoading() {
          this.$vs.loading.close('#app > .con-vs-loading');
          this.isOpenLoading = false;
        },
        getTime(date) {
            if(date) {
                return moment(date).format('hh:mm A');
            } else {
                return '';
            }
        },
        changeFormat(date) {
            if(date) {
                return changeFormatHelper(date);
            } else {
                return 'N/A';
            }
        },
        formatGiftCardCode(code) {
            if(code && code != '') {
                let arr = code.split('');
                let result = '';
                for(let i = 0; i < arr.length; i++) {
                    if(i % 4 == 0) {
                        result = result + ' ' + arr[i];
                    } else {
                        result += arr[i];
                    }
                }
                return result;
            }
            return 'N/A';
        },
        getStatus(status) {
            if(status == this.STATUS_NOT_SOLD_YET) {
                return 'Not Sold Yet';
            } else if(status == this.STATUS_SOLD) {
                return 'Sold';
            } else if(status == this.STATUS_USED_UP) {
                return 'Used up';
            } else if(status == this.STATUS_CANCELLED) {
                return 'Cancelled';
            } else {
                return 'N/A';
            }
        },
        changeSortKey(key) {
            if (key == 0) {
                // return 1;
                this.sort_key.key = 1;
                return;
            } else if (key == 1) {
                // return -1;
                this.sort_key.key = -1;
                return;
            } else if (key == -1) {
                // return 0;
                this.sort_key.key = 0;
                return;
            }
        },
        getSortType() {
            if (this.sort_key.key == 0) {
                return "-created_at";
            } else if (this.sort_key.key == 1) {
                return this.sort_key.type;
            } else if (this.sort_key.key == -1) {
                return "-" + this.sort_key.type;
            }
        },
        showGiftCardHistory(gift_card) {
            this.activeGiftCard = gift_card;
            this.history_key++;
            this.popupRedemptionHistory.isOpen = true;
        },
        searchGiftcard({ target }) {
            // this.search = target.value;
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            if (!this.isOpenLoading) {
                this.openLoadingInDiv();
            }
            this.timer = setTimeout(() => {
                this.search = target.value;
                this.getData();
            }, 500);
        },
        filterStatus(e) {
            this.selected_status = e;
            this.getData();
        },
        filterType(e) {
            this.selected_type = e;
            this.getData();
        },
        changePage(page) {
            this.currentPage = page;
            this.getData();
        },
        selectedDate() {
            this.getData();
        },
        sort() {
            this.selected_status = { id: -1, name: 'Select Status' };
            this.search = '';
            this.date_filter = null;
            if (this.cur_sort_type == this.sort_key.type) {
                this.changeSortKey(this.sort_key.key);
            } else {
                this.sort_key.type = this.cur_sort_type;
                this.sort_key.key = 1;
            }
            this.getData();
        },
        getData() {
            let data = {
                page: this.currentPage,
                'per-page': this.itemsPerPage
            }
            if(this.search != '') {
                data.code = this.search;
            }
            if(this.sort_key.key != 0) {
                data.sort = this.getSortType();
            }
            if(this.selected_status.id != -1) {
                data.status = this.selected_status.status;
            }
            if(this.date_filter) {
                data.created_at = moment(this.date_filter).format('YYYY-MM-DD');
            }
            if(this.selected_type.type != 'all') {
                data.type = this.selected_type.type;
            }
            this.action_type = "Get list";
            if(!this.isOpenLoading) {
                this.openLoadingInDiv();
            }
            this.$store.dispatch('serviceList/GET_GIFTCARD_LIST', data).then((res) => {
                this.closeLoading();
            })
        },
        exportGiftCard(full_export) {
            let data = {};
            if(this.search != '') {
                data.code = this.search;
            }

            if(this.sort_key.key != 0) {
                data.sort = this.getSortType();
            }

            if(this.selected_status.id != -1) {
                data.status = this.selected_status.status;
            }

            if(this.date_filter) {
                data.created_at = moment(this.date_filter).format('YYYY-MM-DD');
            }

            // if(full_export) {
            //     data.export_all = true;
            // } else {
            //     data.page = this.currentPage;
            //     data['per-page'] = this.itemsPerPage;
            // }

            if(!this.isOpenLoading) {
                this.openLoadingInDiv();
            }
            this.action_type = 'Export';

            this.$store.dispatch("serviceList/EXPORT_GIFTCARD", data).then((res) => {
                FileDownload(res.data, `giftcard-${moment().format(this.format_export_date_string)}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                this.closeLoading();
                this.$vs.notify({
                    title: "Notification",
                    text: "Export giftcard success",
                    color: "success",
                    position: "top-right"
                });
            });
        },
        downloadTemplate() {
            if(!this.isOpenLoading) {
                this.openLoadingInDiv();
            }
            this.action_type = 'Download template';

            this.$store.dispatch("serviceList/DOWNLOAD_GIFTCARD_TEMPLATE").then((res) => {
                FileDownload(res.data, `giftcard-template-${moment().format(this.format_export_date_string)}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                this.closeLoading();
                this.$vs.notify({
                    title: "Notification",
                    text: "Download template success",
                    color: "success",
                    position: "top-right"
                });
            });
        },
        onFileChange(e) {
            if(e && e.target && e.target.files[0]) {
                let data = {
                    file: e.target.files[0]
                };
                if(!this.isOpenLoading) {
                    this.openLoadingInDiv();
                }
                this.action_type = 'Import';
                this.$store.dispatch("serviceList/IMPORT_GIFTCARD", data).then(() => {
                    this.closeLoading();
                    this.getData();
                    this.$vs.notify({
                        title: "Notification",
                        text: "Import giftcard success",
                        color: "success",
                        position: "top-right"
                    });
                }).catch((err) => {
                    this.closeLoading();
                    if(err && err.length > 0) {
                        this.getData();
                        for(let i = 0; i < err.length; i++) {
                            if(err[i].code && err[i].code[0]) {
                                this.$vs.notify({
                                    title: "Notification",
                                    text: `Code ${err[i].code}: ${err[i].message ? err[i].message : 'Has already existed'}`,
                                    color: "warning",
                                    position: "top-right"
                                });
                            }
                        }
                    } else {
                        this.getData();
                        this.$vs.notify({
                            title: "Notification",
                            text: "Import giftcard success",
                            color: "success",
                            position: "top-right"
                        });
                    }
                })
            }
        }
    },
    computed: {
        giftCardData() {
            return this.$store.getters['serviceList/giftCardData'];
        }
    },
    created() {
        let data = {
            page: this.currentPage,
            'per-page': this.itemsPerPage,
        }
        this.$store.dispatch('serviceList/GET_GIFTCARD_LIST', data).then((res) => {
            this.loaded_data_num++;
        })
    }
}
</script>